export default __webpack_public_path__ + "static/media/timg.f77a6014.jpg";